import { render } from "./1.PartnerName.vue?vue&type=template&id=1f226058&scoped=true"
import script from "./1.PartnerName.vue?vue&type=script&lang=js"
export * from "./1.PartnerName.vue?vue&type=script&lang=js"

import "./1.PartnerName.vue?vue&type=style&index=0&id=1f226058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f226058"]])

export default __exports__